export function getNameInitials(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string {
  const firstInitial = firstName?.trim().charAt(0) ?? "";
  const lastInitial = lastName?.trim().charAt(0) ?? "";
  return `${firstInitial}${lastInitial}`.toUpperCase();
}
